/* IMPORT */
import isLight from './is_light.js';
/* MAIN */
const isDark = (color) => {
    return !isLight(color);
};
/* EXPORT */
export default isDark;
